import ApiRequestManagerInstance from '../ApiRequestManager';
import EpgEvent from '../../classes/epgEvent';
import EventUtils from '../../utils/events';
import FastEvent from '../../classes/fastEvent';
import MediaProduction from '../../classes/mediaProduction';
import Rail from '../../classes/rail';
import TranslationManager from '../../assets/locale/translationsManager';
import { IDetailRequest } from '../../types/interfaces/rail';
import { RailDisplayMode } from '../../types/enums/rail';
import { store } from '../../store/store';

function detailRequest(id: string, eventId: string) {
  const promise = new Promise<{
    rail: Rail;
    asset: FastEvent | MediaProduction | EpgEvent | null;
  } | null>(async (resolve) => {
    const { user } = store.getState();
    try {
      const response: IDetailRequest = (await ApiRequestManagerInstance.get({
        endpoint: {
          url: 'apiUrl',
          version: 'v4',
          section: `media${user.isAnonymous ? 'free' : ''}`,
          params: '/' + id,
        },
      })) as unknown as IDetailRequest;
      const baseRail = {
        section: {
          title: TranslationManager.get('PAGES.DETAIL.RELATED'),
          presentationType: RailDisplayMode.PHOTO,
          name: 'related',
        },
        shows: {
          data: response.data.similars,
        },
      };
      const rail = new Rail(baseRail);
      const event = EventUtils.createEvent(response.data.media) || null;
      resolve({ rail, asset: event });
    } catch (e) {
      if (eventId) {
        try {
          const response: IDetailRequest = (await ApiRequestManagerInstance.get(
            {
              endpoint: {
                url: 'apiUrl',
                version: 'v4',
                section: `media${user.isAnonymous ? 'free' : ''}`,
                params: '/eventId/' + eventId,
              },
            }
          )) as unknown as IDetailRequest;
          const baseRail = {
            section: {
              title: TranslationManager.get('PAGES.DETAIL.RELATED'),
              presentationType: RailDisplayMode.PHOTO,
              name: 'related',
            },
            shows: {
              data: response.data.similars,
            },
          };
          const rail = new Rail(baseRail);
          const event = EventUtils.createEvent(response.data.media) || null;
          resolve({ rail, asset: event });
        } catch (e) {
          resolve(null);
        }
      } else {
        resolve(null);
      }
    }
  });

  return promise;
}

export default detailRequest;
